import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import InsurersComponent from './InsurersComponent';
import { INSURERS_QUERY } from '../queries';
import { INSURANCE_TYPES_QUERY } from 'features/insuranceDocument/queries/insuranceDocumentQueries';
import { useQueryWithSimpleErrorHandling, useDictionaryHandling } from 'hooks';
import { FakeText } from '@totalsoft/rocket-ui';

const InsurersContainer = ({ resetInsurersLens, insurersLens, validationInsurers, selectedInsurers, insuranceTypeId, readOnly }) => {
  const { loading: insurersDataLoading, data: insurersData } = useQueryWithSimpleErrorHandling(INSURERS_QUERY, {
    variables: { insuranceTypeId: insuranceTypeId },
    skip: !insuranceTypeId
  });

  const { getCodeById: getInsuranceTypeCodeById } = useDictionaryHandling(INSURANCE_TYPES_QUERY, 'insuranceTypes');
  const insuranceTypeCode = useMemo(() => getInsuranceTypeCodeById(insuranceTypeId), [getInsuranceTypeCodeById, insuranceTypeId]);

  useEffect(() => {
    if (!insurersData || !selectedInsurers) return;

    let list = [];
    insurersData.insurers.forEach(insurer => {
      const selectedInsurer = selectedInsurers.find(x => x.insurerId === insurer.id);
      list.push({
        id: insurer.id,
        name: insurer.name,
        selected: Boolean(selectedInsurer),
        requestedCommissionPercent: selectedInsurer?.requestedCommissionPercent
      });
    });
    resetInsurersLens(list);
  }, [insurersData, selectedInsurers, resetInsurersLens]);

  return insurersDataLoading ? (
    <FakeText lines={3} />
  ) : (
    <InsurersComponent
      insurersLens={insurersLens}
      validationInsurers={validationInsurers}
      insuranceTypeCode={insuranceTypeCode}
      readOnly={readOnly}
    />
  );
};
InsurersContainer.propTypes = {
  resetInsurersLens: PropTypes.func.isRequired,
  insurersLens: PropTypes.object.isRequired,
  validationInsurers: PropTypes.object,
  selectedInsurers: PropTypes.array,
  insuranceTypeId: PropTypes.number,
  readOnly: PropTypes.bool.isRequired
};
export default InsurersContainer;
